import { common } from './common.icons';

export const IconScale = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      viewBox="0 0 30 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-size ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
    >
      <path
        d="M8.33268 1.66732H2.46602C2.02419 1.66732 1.66602 2.02545 1.66602 2.46732L1.66602 11.534C1.66602 11.9758 2.02419 12.334 2.46602 12.334L27.5327 12.334C27.9745 12.334 28.3327 11.9758 28.3327 11.534V2.46732C28.3327 2.02545 27.9745 1.66732 27.5327 1.66732H21.666M8.33268 1.66732V5.66732M8.33268 1.66732H14.9993M21.666 1.66732L14.9993 1.66732M21.666 1.66732V5.66732M14.9993 1.66732V5.66732"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
